(function () {
  var STAR_PATH = "M12 17.5L6.122 20.59L7.245 14.045L2.49 9.41L9.061 8.455L12 2.5L14.939 8.455L21.51 9.41L16.755 14.045L17.878 20.59L12 17.5Z";
  var SVG_NS = "http://www.w3.org/2000/svg";

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function buildStars(rating) {
    var wrapper = element("div", "bn-rating-stars bn-testimonial-card__stars");
    wrapper.setAttribute("role", "img");
    wrapper.setAttribute("aria-label", rating + "/5");

    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS(SVG_NS, "svg");
      svg.setAttribute("width", "16");
      svg.setAttribute("height", "16");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.setAttribute("fill", "currentColor");
      svg.setAttribute("aria-hidden", "true");
      if (i > rating) svg.setAttribute("class", "is-empty");

      var path = document.createElementNS(SVG_NS, "path");
      path.setAttribute("d", STAR_PATH);
      svg.appendChild(path);
      wrapper.appendChild(svg);
    }

    return wrapper;
  }

  // "country" è un codice ISO (IT, DE, PL...): il nome viene mostrato nella lingua del negozio.
  function countryName(code) {
    var value = String(code).trim();
    if (!/^[a-z]{2}$/i.test(value) || typeof Intl === "undefined" || !Intl.DisplayNames) return value;

    try {
      var locale = document.documentElement.lang || navigator.language || "it";
      return new Intl.DisplayNames([locale], { type: "region" }).of(value.toUpperCase()) || value;
    } catch (error) {
      return value;
    }
  }

  // Bandiere SVG da flagcdn.com: basta il codice ISO nel JSON, nessun file da aggiungere.
  function buildFlag(code) {
    var value = String(code).trim().toLowerCase();
    if (!/^[a-z]{2}$/.test(value)) return null;

    var img = document.createElement("img");
    img.className = "bn-reviews__flag";
    img.src = "https://flagcdn.com/" + value + ".svg";
    img.alt = "";
    img.width = 20;
    img.height = 15;
    img.loading = "lazy";
    img.decoding = "async";
    img.addEventListener("error", function () {
      img.remove();
    });

    return img;
  }

  function buildCard(review) {
    var rating = Math.min(Math.max(parseInt(review.rating, 10) || 5, 1), 5);
    var card = element("article", "bn-surface-card bn-testimonial-card");
    if (review.lang) card.setAttribute("lang", String(review.lang));

    var quoteMark = element("span", "bn-reviews__quote-mark", "\u201C");
    quoteMark.setAttribute("aria-hidden", "true");
    card.appendChild(quoteMark);
    card.appendChild(buildStars(rating));
    card.appendChild(element("blockquote", "bn-testimonial-card__copy", String(review.text)));
    if (review.name) card.appendChild(element("p", "bn-testimonial-card__name", String(review.name)));
    var meta = [review.role, review.country ? countryName(review.country) : ""].filter(Boolean).join(" · ");
    if (meta) {
      var metaNode = element("p", "bn-testimonial-card__role bn-reviews__meta");
      var flag = review.country ? buildFlag(review.country) : null;
      if (flag) metaNode.appendChild(flag);
      metaNode.appendChild(document.createTextNode(String(meta)));
      card.appendChild(metaNode);
    }

    return card;
  }

  function buildSummary(root, reviews) {
    var summary = root.querySelector("[data-reviews-summary]");
    if (!summary) return;

    var total = reviews.reduce(function (sum, review) {
      return sum + Math.min(Math.max(parseInt(review.rating, 10) || 5, 1), 5);
    }, 0);
    var average = total / reviews.length;
    var countries = [];
    reviews.forEach(function (review) {
      var code = review.country ? String(review.country).trim().toLowerCase() : "";
      if (code && countries.indexOf(code) === -1) countries.push(code);
    });

    var score = summary.querySelector("[data-reviews-score]");
    if (score) score.textContent = average.toLocaleString(document.documentElement.lang || "it", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    var stars = summary.querySelector("[data-reviews-stars]");
    if (stars) stars.appendChild(buildStars(Math.round(average)));

    var text = summary.querySelector("[data-reviews-summary-text]");
    if (text) {
      text.textContent = (text.getAttribute("data-template") || "")
        .replace("%TOTAL%", reviews.length)
        .replace("%COUNTRIES%", countries.length);
    }

    var flags = summary.querySelector("[data-reviews-flags]");
    if (flags) {
      countries.forEach(function (code) {
        var flag = buildFlag(code);
        if (flag) flags.appendChild(flag);
      });
    }

    summary.hidden = false;
  }

  // Scorrimento infinito: la serie di card viene duplicata e la traccia scorre di metà
  // della sua larghezza (vedi bn-reviews.css). Le copie sono nascoste ai lettori di schermo.
  function initMarquee(root, track) {
    var cards = Array.prototype.slice.call(track.children);
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("inert", "");
      track.appendChild(clone);
    });

    track.style.setProperty("--bn-reviews-duration", cards.length * 9 + "s");
    root.classList.add("is-marquee");

    // Su touch non c'è hover: un tocco ferma il carosello, il tocco successivo lo riavvia.
    // Sui dispositivi con mouse la pausa la gestisce già :hover nel CSS.
    var canHover = window.matchMedia && window.matchMedia("(hover: hover)").matches;
    if (!canHover) {
      track.addEventListener("click", function () {
        track.classList.toggle("is-paused");
      });
    }
  }

  function initReviews(root) {
    var src = root.getAttribute("data-reviews-src");
    var track = root.querySelector("[data-reviews-track]");
    if (!src || !track) return;

    fetch(src, { credentials: "omit" })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function (data) {
        var reviews = (data && Array.isArray(data.reviews) ? data.reviews : []).filter(function (review) {
          return review && review.text;
        });
        if (reviews.length === 0) return;

        reviews.forEach(function (review) {
          track.appendChild(buildCard(review));
        });

        buildSummary(root, reviews);
        root.hidden = false;
        initMarquee(root, track);

        // Le stelle "si accendono" quando la sezione entra nello schermo.
        if ("IntersectionObserver" in window) {
          var observer = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            root.classList.add("is-in-view");
            observer.disconnect();
          }, { threshold: 0.2 });
          observer.observe(root);
        } else {
          root.classList.add("is-in-view");
        }
      })
      .catch(function (error) {
        console.warn("[bn-reviews] Impossibile caricare le recensioni:", error);
      });
  }

  onReady(function () {
    Array.prototype.forEach.call(document.querySelectorAll("[data-reviews]"), initReviews);
  });
})();
